import { render, staticRenderFns } from "./ItensLaudoCheckList.vue?vue&type=template&id=548da5e6"
import script from "./ItensLaudoCheckList.vue?vue&type=script&lang=js"
export * from "./ItensLaudoCheckList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports